import axios from 'axios';
const API_URL = process.env.REACT_APP_API_ENDPOINT;
axios.defaults.withCredentials = true;

export const customerAnalysisReport = async (values) => {
    const res = await axios.post(`${API_URL}customer-analysis-report/data-statistics`, values);
    return res;
};
